import React ,{useState, useEffect, useCallback} from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import defaultBannerImg from 'images/default_campaign_banner_163x163.png'
import constants from 'utils/constants'
import server from 'server/serverController2'
import Slider from 'react-slick';

import { MainBannerBlock, MainBannerItem, BannerDots } from 'components/presenters/banner/MainBanner';

export default function MainBanner({type}) {
    const REQ_END_POINT = type === 'company' ? 'banners/companies' : 'banners/main';
    //페이지가 렌더링이 되었을 때 한번 호출
    const [bannerList, setBannerList] = useState([]);

    const getMainBannerList = useCallback(async () => {
        try {
            const response = await server.getRequestData(REQ_END_POINT);
            if(response.success !== 1) {
                const errData = response.error.res_data;
                throw errData;
            }

            const { banners } = response.data;
            
            setBannerList(banners);
        } catch(error) {
            console.log(error);
        }
    });

    useEffect(() => {
      getMainBannerList();
    }, [type]);

    

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoPlaySpeed: 500,
        appendDots: (dots)=>{
            return(
                <BannerDots dots={dots}/>
            )
        }
    };
    return(
        <MainBannerBlock>
            <Slider {...settings}>
                {bannerList?.map(banner => (
                    banner.data.banner_cover_img && banner.status === 'published' && (
                        <MainBannerItem
                            key={`main_banner_no_${banner.no}`}
                            type={banner.type}
                            externalLink={banner.data.link}
                            path={banner.data.path}
                            imageSrc={
                                banner.data.banner_cover_img ? (
                                `${constants['imagePath']}/banner_cover_img/${banner['data']['banner_cover_img']}`) 
                                : defaultBannerImg
                            }
                        />
                    )
                ))} 
            </Slider>
        </MainBannerBlock>
    )
}

const DotWrapper = styled.div`
    position : absolute;
    left:calc(100vw * (17 / 375));
    bottom:calc(100vw * (21 / 375));
    width: fit-content;
    height: calc(100vw * (7 / 375));
`;

const BannerDot = styled.span`
    display: inline-block;
    margin: 0 calc(100vw * (4.5 / 375));
    width: calc(100vw * (7 / 375));
    height: calc(100vw * (7 / 375));
    background: #ffffff66;
    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
    &.activated {
        background: #ffffff;
    }
    border-radius: 100%;
`;
const BannerLink = styled(Link)`
    display: block;
`
const BannerExternalLink = styled.a`
    display: block;
`
const BannerImg = styled.img`
    image-rendering: -moz-crisp-edges;         /* Firefox */
    image-rendering:   -o-crisp-edges;         /* Opera */
    image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
`;